export const DROPDOWN_OPTION_ROW_HEIGHT = 40;
export const DROPDOWN_HEADER_ROW_HEIGHT = 34;

export const DROPDOWN_ROW_HEIGHT_STYLE = {
  '--dropdown-option-row-height': `${DROPDOWN_OPTION_ROW_HEIGHT}px`,
  '--dropdown-header-row-height': `${DROPDOWN_HEADER_ROW_HEIGHT}px`,
};
